function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 295,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1615 -2901) rotate(90)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3101 1323) rotate(90)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M144,0,288,200H0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 144 41.07443237304688 L 46.85359191894531 176 L 241.1464080810547 176 L 144 41.07443237304688 M 144 0 L 288 200 L 0 200 L 144 0 Z",
  stroke: "none",
  fill: "#212121"
})), /*#__PURE__*/React.createElement("path", {
  d: "M144,0,288,200H0Z",
  transform: "translate(3145 1611) rotate(-90)",
  fill: "#212121"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3111 1320)",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3101 -1308)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3101 1308)",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3101 -1264)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3101 1308)",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3101 -1220)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3101 1308)",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3101 -1176)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3101 1308)",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3101 -1132)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3101 1308)",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3101 -1088)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3101 1308)",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3101 -1044)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3101 1308)",
  fill: "#424242"
}))));

var SvgFlipVertical = function SvgFlipVertical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 444,
    viewBox: "0 0 295 444",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlipVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flip-vertical.bbca9eac.svg";
export { ForwardRef as ReactComponent };